import React, {useState} from "react";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {csrfHeader} from "./lib/utils";

const RakutenAttribute = ({name, value, defaultValue, setAttributes}) => {
    console.log({value, defaultValue});
    // カスタム値が空の場合はデフォルト値を表示
    const displayValue = value || (defaultValue?.value ? `${defaultValue.value}${defaultValue.unit || ''}` : null) || '未設定';
    return <>
        <a href='#' onClick={setAttributes}>{displayValue}</a>
    </>
}

const UNITS = {
    "総入数": ['本', '個'],
    "総個数": ['本', '個'],
    "本体横幅": ['cm'],
    "本体縦幅": ['cm'],
};

export const RakutenAttributes = ({required, rakuten_attributes, default_attributes, defined_attributes}) => {
    const [show, setShow] = useState(false);
    // カスタム属性が空の場合、デフォルト属性の値を初期値として使用
    const initAttrs = {...rakuten_attributes};
    required.forEach(attr => {
        if (!initAttrs[attr] && default_attributes?.[attr]?.value) {
            initAttrs[attr] = default_attributes[attr].value;
        }
    });
    const [attrs, setAttrs] = useState(initAttrs);
    const setAttributes = () => setShow(true);
    const handleClose = () => setShow(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        save().then(() => location.reload());
        return false;
    }
    console.log({rakuten_attributes, default_attributes})
    const save = async () => {
        const res = await fetch(`${new URL(location.href).pathname}/attrs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...csrfHeader(),
            },
            body: JSON.stringify({attrs}),
            credentials: "include",
            mode: "cors",
        })
        console.log(res);
    }
    const updateAttr = (attr, value) => {
        setAttrs({...attrs, [attr]: value});
    };
    return <>
        {
            required.map(attr => <tr key={`rakuten-attr-${attr}`}>
                <td>{attr}</td>
                <td>
                    <RakutenAttribute name={attr} value={rakuten_attributes[attr]} defaultValue={default_attributes?.[attr]} setAttributes={setAttributes} />
                </td>
            </tr>)
        }
        {
            <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>楽天商品属性を編集</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form id="rakuten-attrs-from" onSubmit={handleSubmit}>
                        {
                            required.map(attr => {
                                const unitOptions = UNITS[attr];
                                const hasUnit = !!unitOptions;
                                const options = defined_attributes[attr];
                                const selectList = !!options;
                                return <Form.Group as={Row} key={`rakuten-fg-${attr}`}>
                                    <Form.Label column sm={3}>
                                        {attr}
                                    </Form.Label>
                                    <Col sm={hasUnit ? 6 : 9}>
                                        {
                                            selectList &&
                                            <Form.Control as="select" custom value={attrs[attr] || ''}
                                                          onChange={e => updateAttr(attr, e.target.value)}>
                                                {
                                                    options.map((option, i) => <option key={`${attr}-${i}`}>{option}</option>)
                                                }
                                            </Form.Control>
                                        }
                                        {
                                            !selectList &&
                                            <Form.Control key={`rakuten-input-${attr}`} value={attrs[attr] || ''}
                                                          onChange={e => updateAttr(attr, e.target.value)}/>
                                        }
                                    </Col>
                                    {
                                        hasUnit &&
                                        <Col sm={3}>
                                            <Form.Control value={attrs.unit} onChange={e => setAttrs({
                                                ...attrs,
                                                unit: e.target.value
                                            })} as="select">
                                                {
                                                    unitOptions?.length > 1 && <option>選択(必須)</option>
                                                }
                                                {
                                                    unitOptions.map(option => <option key={`${attr}-${option}`} value={option}>{option}</option>)
                                                }
                                            </Form.Control>
                                        </Col>
                                    }
                                </Form.Group>;
                            })
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>キャンセル</Button>
                    <Button variant="primary" form="rakuten-attrs-from" type="submit">保存</Button>
                </Modal.Footer>
            </Modal>
        }
    </>
}